var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2153_3973)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -9208.33,
    y: -6547,
    width: 21622,
    height: 22560.7,
    stroke: "black",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22436 11.977L9.22454 11.9768L12.7037 8.47938L12.7729 8.40985L12.7047 8.33934L12.249 7.86799L12.178 7.79461L12.1061 7.86704L8.92683 11.0693L7.76863 9.91106L7.69792 9.84035L7.62721 9.91106L7.16366 10.3746L7.09295 10.4453L7.16366 10.516L8.622 11.9744L8.62198 11.9744L8.62346 11.9758C8.66139 12.0122 8.70705 12.0473 8.75643 12.0738C8.80496 12.0998 8.8632 12.1208 8.92448 12.1208C9.04073 12.1208 9.15332 12.048 9.22436 11.977Z",
    fill: "#323030",
    stroke: "#323030",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.82812,
    y: 3.82812,
    width: 12.3333,
    height: 12.3333,
    rx: 0.833333,
    stroke: "#323030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2153_3973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAll);
export default __webpack_public_path__ + "static/media/select-all.fcca0f5b33a3395a91974b3c618882ab.svg";
export { ForwardRef as ReactComponent };